import { createTheme } from '@mui/material'
import { BREAKPOINTS, SPACE } from './layout'

const baseTheme = createTheme({
  breakpoints: { values: { ...BREAKPOINTS } },
  /* COLORS */
  palette: {
    primary: {
      main: '#B246F6',
    },
    secondary: {
      main: '#B246F6',
    },
    success: {
      main: '#00C389',
    },
    error: {
      main: '#F8485E',
    },
    warning: {
      main: '#FCBA03',
    },
    background: {
      default: '#101011',
      paper: '#242D33',
    },
    text: {
      disabled: 'rgba(235, 235, 255, 0.55)', // DS text-soft: ink at 55% (placeholder labels)
      // Titles, labels and primary copy: full-strength.
      primary: '#EBEBFF',
      // Explainer / secondary copy: the same colour at 55%.
      secondary: 'rgba(235, 235, 255, 0.55)',
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    divider: '#242D33',
    mode: 'dark',
  },
  /* TYPOGRAPHY */
  typography: {
    fontFamily: 'Nunito-Sans',
    button: {
      textTransform: 'none',
      fontWeight: '600',
    },
    // Sizes and line heights are steps on the Zumo DS type ladder (size and
    // line height are paired, fixed px). Phones use one step; from the tablet
    // breakpoint (sm, 640px), where the column widens, each moves up one step.
    // Weights stay Nunito's (400 / 600); the DS equivalents are 350 / 500.
    //   DS step:   body 16/24   small 14/20   intro 18/27   lead 20/28   h3 24/30
    h6: {
      fontSize: '20px', // lead
      lineHeight: '28px',
      [`@media (min-width:${BREAKPOINTS.sm}px)`]: {
        fontSize: '24px',
        lineHeight: '30px',
      }, // h3
    },
    body1: {
      fontSize: '16px', // body
      lineHeight: '24px',
      [`@media (min-width:${BREAKPOINTS.sm}px)`]: {
        fontSize: '18px',
        lineHeight: '27px',
      }, // intro
    },
    body2: {
      // Explainer text is always the secondary (55%) colour.
      color: 'rgba(235, 235, 255, 0.55)',
      fontSize: '14px', // small
      lineHeight: '20px',
      [`@media (min-width:${BREAKPOINTS.sm}px)`]: {
        fontSize: '16px',
        lineHeight: '24px',
      }, // body
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: SPACE.md,
          // Label follows the body step (DS: button.font-size = body), so the
          // CTA is never smaller than the copy above it. Set here rather than
          // in typography.button because MUI's size="large" class outranks that.
          // Height: DS control height (52px) at every width.
          fontSize: '16px', // body
          lineHeight: '24px',
          minHeight: '52px',
          [`@media (min-width:${BREAKPOINTS.sm}px)`]: {
            fontSize: '18px', // intro
            lineHeight: '27px',
          },
          // CTA label is the client's ground colour (DS: on-accent-vivid =
          // surface), so Zumo gets #101011 and a partner brand gets its own.
          // Set here rather than via palette.primary.contrastText because
          // createThemeForOrganisation re-derives `primary` (and would reset
          // contrastText) for every org.
          '&.MuiButton-containedPrimary': {
            color: theme.palette.background.default,
          },
          // Not-yet-clickable: the whole button (fill and label together) dims
          // via opacity, so the label keeps its colour and stays legible.
          '&.Mui-disabled': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.default,
            opacity: 0.3,
          },
        }),
      },
    },
  },
})

export default baseTheme
